import Vue from "vue";
import { RequestQueryBuilder, CondOperator } from "@nestjsx/crud-request";

const RequestBuilder = {};
RequestBuilder.install = function(VueJs) {
  RequestBuilder.create = function() {
    return RequestQueryBuilder.create();
  };
  RequestBuilder.operator = function() {
    return CondOperator;
  };

  if (!VueJs.$requestBuilder) {
    VueJs.$requestBuilder = RequestBuilder;
    Object.defineProperties(VueJs.prototype, {
      $requestBuilder: {
        get() {
          return RequestBuilder;
        },
      },
    });
  }
};

Vue.use(RequestBuilder);
